<template>
  <div class="relative h-[67vh] w-full overflow-y-auto px-6">
    <div class="max-h-[55vh] pb-5">
      <div v-if="favoriteCarrierProducts.length !== 0 && !loading" class="">
        <div class="flex w-full items-center gap-0.5 py-3 pl-9.5">
          <HRPin :pinned="true" class="pointer-events-none" :size="ComponentSize.xl" />
          <p class="text-body-default-m">{{ t("organisation_pinned_products") }}</p>
        </div>
        <div class="border-bdr-default mb-5 rounded-xl border px-2 pb-1">
          <div class="flex w-full gap-3 px-3 py-2">
            <div class="min-w-9" />
            <p class="text-body-small w-full pr-4 text-left">{{ t("product") }}</p>
            <p v-if="!isDFM" class="text-body-small ml-auto min-w-20 text-right">
              {{ t("price") }}
            </p>
          </div>
          <template v-for="(product, index) in favoriteCarrierProducts" :key="product.uid">
            <div v-if="!loading" class="flex flex-col" :data-cps="`${product.carrier_product_service}`">
              <div
                class="hover:bg-bgr-secondary relative w-auto cursor-pointer rounded-lg transition-all duration-300"
                :class="cpsValue === product.uid ? 'bg-bgr-secondary' : ''"
                @click="selectCps(product)"
              >
                <div class="flex gap-3 px-3 py-2">
                  <Avatar
                    class="transition duration-300"
                    :entity="{ image: getCarrierLogoUrl(product.carrier) }"
                    :size="ComponentSize.lg"
                  />
                  <p class="text-body-large mt-1.5 font-medium">{{ product.title }}</p>
                  <p v-if="!isDFM" class="text-body-small mt-2 ml-auto w-[80px] text-right">
                    {{
                      useFormatPrice(
                        useDecidePriceExclOrIncl({
                          price_excl_tax: product.sales_price_excl_vat,
                          price_incl_tax: product.sales_price_incl_vat,
                        }),
                        "auto",
                        product.currency
                      )
                    }}
                  </p>
                </div>
                <div
                  class="grid overflow-hidden transition-all duration-300"
                  :class="
                    isDroppoint(product.carrier_product_service) && droppoints.length !== 0 && cpsValue == product.uid
                      ? 'grid-rows-1fr pb-3'
                      : 'grid-rows-0'
                  "
                >
                  <div v-if="loadingDroppoints" class="flex w-full gap-2.5 overflow-hidden pr-3 pl-15">
                    <div class="flex w-47 flex-col gap-1">
                      <Bone class="h-4.75 w-18.75" />
                      <Bone class="h-9 w-full rounded-xl" />
                    </div>
                    <div class="flex w-full flex-col gap-1">
                      <Bone class="h-4.75 w-18.75" />
                      <Bone class="h-9 w-full rounded-xl" />
                    </div>
                  </div>
                  <div v-else class="flex w-full gap-2.5 overflow-hidden pr-3 pl-15" @click.stop="">
                    <InputText v-model="zip_code" class="w-47" :label="t('zip_code')" />
                    <Dropdown
                      v-model="droppoint"
                      class="w-full"
                      :options="droppoints"
                      pre-selected
                      :label="t('select_droppoint')"
                      :placeholder="t('select_droppoint')"
                    />
                  </div>
                </div>
                <Overlay
                  v-if="isDroppoint(product.carrier_product_service) && loading && cpsValue == product.uid"
                  class="absolute inset-0"
                />
              </div>
              <Divider v-if="index !== favoriteCarrierProducts.length - 1" />
            </div>
          </template>
        </div>
      </div>
      <div v-if="notFavoriteCarrierProducts.length !== 0 && !loading" class="">
        <div class="flex w-full gap-3 px-3 py-2">
          <div class="min-w-9" />
          <p class="text-body-small w-full pr-4 text-left">{{ t("product") }}</p>
          <p v-if="!isDFM" class="text-body-small ml-auto min-w-[80px] text-right">
            {{ t("price") }}
          </p>
        </div>
        <template v-for="(product, index) in notFavoriteCarrierProducts" :key="product.uid">
          <div v-if="!loading" class="flex flex-col" :data-cps="`${product.carrier_product_service}`">
            <div
              class="hover:bg-bgr-secondary relative w-auto cursor-pointer rounded-lg transition-all duration-300"
              :class="cpsValue === product.uid ? 'bg-bgr-secondary' : ''"
              @click="selectCps(product)"
            >
              <div class="flex gap-3 px-3 py-2">
                <Avatar
                  class="transition duration-300"
                  :entity="{ image: getCarrierLogoUrl(product.carrier) }"
                  :size="ComponentSize.lg"
                />
                <p class="text-body-large mt-1.5 font-medium">{{ product.title }}</p>
                <p v-if="!isDFM" class="text-body-small mt-2 ml-auto w-[80px] text-right">
                  {{
                    useFormatPrice(
                      useDecidePriceExclOrIncl({
                        price_excl_tax: product.sales_price_excl_vat,
                        price_incl_tax: product.sales_price_incl_vat,
                      }),
                      "auto",
                      product.currency
                    )
                  }}
                </p>
              </div>
              <div
                class="grid overflow-hidden transition-all duration-300"
                :class="
                  isDroppoint(product.carrier_product_service) && droppoints.length !== 0 && cpsValue == product.uid
                    ? 'grid-rows-1fr pb-3'
                    : 'grid-rows-0'
                "
              >
                <div v-if="loadingDroppoints" class="flex w-full gap-2.5 overflow-hidden pr-3 pl-15">
                  <div class="flex w-47 flex-col gap-1">
                    <Bone class="h-4.75 w-18.75" />
                    <Bone class="h-9 w-full rounded-xl" />
                  </div>
                  <div class="flex w-full flex-col gap-1">
                    <Bone class="h-4.75 w-18.75" />
                    <Bone class="h-9 w-full rounded-xl" />
                  </div>
                </div>
                <div v-else class="flex w-full gap-2.5 overflow-hidden pr-3 pl-15" @click.stop="">
                  <InputText v-model="zip_code" class="w-47" :label="t('zip_code')" />
                  <Dropdown
                    v-model="droppoint"
                    class="w-full"
                    :options="droppoints"
                    pre-selected
                    :label="t('select_droppoint')"
                    :placeholder="t('select_droppoint')"
                  />
                </div>
              </div>
              <Overlay
                v-if="isDroppoint(product.carrier_product_service) && loading && cpsValue == product.uid"
                class="absolute inset-0"
              />
            </div>
            <Divider v-if="index !== notFavoriteCarrierProducts.length - 1" />
          </div>
        </template>
      </div>
      <template v-if="loading">
        <div v-for="i in 11" :key="i">
          <div class="flex h-fit items-center gap-3 px-3 py-2">
            <Bone class="size-9 rounded-lg" />
            <Bone :size="ComponentSize.xl" class="mt-1.5 h-6 w-1/2" type="heavy" />
            <Bone v-if="!isDFM" :size="ComponentSize.sm" type="heavy" class="mt-2 ml-auto w-20" />
          </div>
          <Divider v-if="i !== 11" />
        </div>
      </template>
    </div>
    <EmptyCarrier v-if="products.length == 0 && !loading" @goback="emit('goback')" />
  </div>
</template>

<script setup lang="ts">
  import type { Product } from "~/types/shipment";

  import useCps from "../../composables/useCps";
  import EmptyCarrier from "./emptyViews/emptyCarrier.vue";

  const { t } = useI18n();

  const emit = defineEmits(["addExtraServices", "goback", "skipInsurance", "loading"]);

  const props = defineProps<{
    values: any;
    mode: string;
  }>();

  const zip_code = ref("");

  const favoritCarriers = ref<{ carrier_product_service: string }[]>([]);

  const receiver = computed(() => ({
    street1: props.values.receiver.street1,
    country: props.values.receiver.country,
    zip_code: props.values.receiver.zip_code,
    city: props.values.receiver.city,
    business: props.values.receiver.business,
  }));

  const favoriteCarrierProducts = computed(() => {
    return favoritCarriers.value
      .map((fav) =>
        products.value.find((product: Product) => product.carrier_product_service === fav.carrier_product_service)
      )
      .filter((product) => product !== undefined);
  });

  const notFavoriteCarrierProducts = computed(() => {
    return products.value.filter(
      (product: Product) =>
        !favoritCarriers.value.some((fav) => fav.carrier_product_service === product.carrier_product_service)
    );
  });

  const { products, droppoints, loading, loadingDroppoints, fetchProducts, fetchServicePoints, fetchExtraServices } =
    await useCps();

  const { accountIsBusiness, isDFM, accountLevel, isSKYNET } = useWorkspacesStore();

  const fetchFavoriteProducts = async () => {
    homeFetch("favorite-carrier-product-services").then((response) => {
      favoritCarriers.value = response.data as { carrier_product_service: string }[];
    });
  };

  onMounted(() => {
    fetchFavoriteProducts();
    const sender = {
      street1: props.values.sender.street1,
      country: props.values.sender.country,
      zip_code: props.values.sender.zip_code,
      city: props.values.sender.city,
    };

    zip_code.value = receiver.value.zip_code;
    fetchProducts(
      sender,
      receiver.value,
      props.values.weight,
      props.values.height,
      props.values.width,
      props.values.length,
      props.values.order_lines || [], //#TODO: Add orderlines
      { return: props.mode == "return" }
    ).then(() => {
      if (cpsValue && products.value && products.value.length > 0) {
        const selectedProduct = products.value.find((product: Product) => product.uid === cpsValue.value);
        if (!selectedProduct) return;

        selectCps(selectedProduct);
      }
    });
  });

  const debounceTimeout = ref(null);

  const debounce = async () => {
    if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
    debounceTimeout.value = setTimeout(async () => {
      if (!cpsValue.value) return;
      const cps = products.value.find((product: Product) => product.uid === cpsValue.value);
      if (!cps) return;
      const receiverObject = { ...receiver.value, zip_code: zip_code.value };

      await fetchServicePoints(cps.carrier, receiverObject, true);
    }, 500); // delay for half second
  };

  watch(
    () => zip_code.value,
    (value) => {
      if (value && carrier_product_service.value && isDroppoint(carrier_product_service.value)) {
        debounce();
      }
    }
  );

  const selectCps = async (product: Product) => {
    const isSameCps = carrier_product_service.value === product.carrier_product_service;
    cpsValue.value = product.uid;
    carrier_product_service.value = product.carrier_product_service;
    carrier_product_title.value = product.title;
    carrier_product_price.value = accountIsBusiness ? product.sales_price_excl_vat : product.sales_price_incl_vat;
    carrier_product_currency.value = product.currency;
    if (isDroppoint(product.carrier_product_service)) {
      await fetchServicePoints(product.carrier, receiver.value);
    }
    if (product.carrier === "dfm" && isDFM) {
      emit("skipInsurance", true);
    } else if (isSKYNET) {
      emit("skipInsurance", true);
    } else if (accountLevel === "ENTERPRISE") {
      emit("skipInsurance", true);
    } else {
      emit("skipInsurance", false);
    }
    if (product.carrier === "dfm") {
      let services = [];
      if (product.service_codes) {
        services = Array.isArray(product.service_codes) ? product.service_codes : Object.values(product.service_codes);
      }

      if (services.length > 0) {
        emit("loading", true);
        const extraServices = await fetchExtraServices(product.carrier, product.carrier_product_service, services);
        emit("loading", false);
        emit("addExtraServices", { services: extraServices.data, reset: !isSameCps });
      } else {
        emit("addExtraServices", { services: [], reset: !isSameCps });
      }
    } else {
      emit("addExtraServices", { services: [], reset: !isSameCps });
    }
  };

  const { value: cpsValue } = useField(() => "cpsUid", undefined, {
    syncVModel: true,
  });

  const { value: carrier_product_service } = useField(() => "carrier_product_service", undefined, {
    syncVModel: true,
  });

  const { value: droppoint } = useField(() => "droppoint", undefined, {
    syncVModel: true,
  });

  const { value: carrier_product_title } = useField(() => "carrier_product_title", undefined, {
    syncVModel: true,
  });

  const { value: carrier_product_price } = useField(() => "carrier_product_price", undefined, {
    syncVModel: true,
  });

  // The currency the quote is in. Everything priced against this quote - insurance included -
  // is displayed in it, and it is what `GET /insurance?currency=` is asked for.
  const { value: carrier_product_currency } = useField(() => "carrier_product_currency", undefined, {
    syncVModel: true,
  });
</script>
